import React from 'react';
import ReactDOM from 'react-dom';
import Dashboard from './pages/Dashboard';

import 'core-js';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import '@livingsecurity/cyberblocks/dist/styles/fontawesome-all.min.css';
import './styles/index.scss';
import './utils/i18n';

ReactDOM.render(
  <React.StrictMode>
    <Dashboard />
  </React.StrictMode>,
  document.getElementById('root'),
);
